<template>
    <div class="preview-container">
        <p class="title-info">可将关联的小程序展示在个人空间</p>
        <div class="preview-img">
            <img :src="!!activeIndex ? previewImg : emptyPreviewImg" class="img">
            <div class="active-info" v-if="activeIndex">
                {{list[activeIndex - 1].name}}
            </div>
        </div>
        <div class="choose-area">
            <p class="title">展示中的小程序（单选）</p>
            <p class="tip"><i class="el-icon-warning"></i>配置完成后，前端将在20分钟内更新入口样式</p>
            <div class="list">
                <div class="row" v-for="(item, index) in list" :key="index" @click="changeStatus(index)">
                    <i class="checkbox" :class="{active: item.status === 2}"></i>
                    <avatar class="avatar-preview" :url="item.logo" :size="32"></avatar>
                    <span class="name">{{item.name}}</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Avatar from '@/components/Avatar.vue';
import dao from '@/lib/dao.js';
export default {
    props: {
        list: {
            type: Array,
            default() {
                return []
            }
        }
    },
    components: {
        Avatar
    },
    data() {
        return {
            activeIndex: 0,
            emptyPreviewImg: require('./../../assets/empty_preview.png'),
            previewImg: require('./../../assets/Artboard@2x.png'),
        }
    },
    methods: {
        changeStatus(index) {
            let item = this.list[index];
            let newStatus = item.status == 2 ? 3 : 2;
            dao.up.upStatusUpdate({
                appId: item.vAppId,
                status: newStatus
            }).then(_ => {
                item.status = newStatus;
                if (this.activeIndex) {
                    this.list[this.activeIndex - 1].status = 3;
                }
                if (newStatus === 2) {
                    this.activeIndex = index + 1;
                } else {
                    this.activeIndex = 0;
                }
            }).catch(msg => {
                this.$message.error(msg);
            });
        },
        getActiveIndex() {
            let i = 0;
            let len = this.list.length;
            for (; i < len; i++) {
                if (this.list[i].status === 2) {
                    this.activeIndex = i + 1;
                    break;
                }
            }
        }
    },
    mounted() {
        this.getActiveIndex();
    }
}
</script>
<style lang="less" scoped>
.preview-container {
    background: #fff;
    border: 1px solid #E0E5EC;
    padding: 20px;

    .title-info {
        color: #5C667E;
        font-size: 14px;
        line-height: 20px;
        margin-bottom: 12px;
    }

    .preview-img {
        position: relative;
        width: 300px;
        height: 600px;
        display: inline-block;
        .img {
            width: 100%;
            height: 100%;
        }
        .active-info {
            position: absolute;
            top: 307px;
            left: 9px;
            background: #fff;
            line-height: 31px;
            font-size: 12px;
            display: inline-block;
            overflow: hidden;
            text-overflow: ellipsis;
            width: 220px;
            white-space: nowrap;
            margin-left: 18px;
        }
    }

    .choose-area {
        width: 300px;
        height: 600px;
        background: #F3F3F3;
        padding: 10px;
        font-size: 12px;
        color: #5C667E;
        display: inline-block;
        vertical-align: top;
        margin-left: 15px;
        box-sizing: border-box;
        .list {
            height: 550px;
        }
        .title {
            line-height: 17px;
        }
        .row {
            height: 32px;
            margin: 12px 0;
            line-height: 32px;
            cursor: pointer;

            .checkbox {
                background: #fff;
                border: 2px solid #E0E5EF;
                width: 16px;
                height: 16px;
                box-sizing: border-box;
                display: inline-block;
                vertical-align: middle;
                margin-right: 5px;

                &.active {
                    background: url(../../assets/selected.png) center center no-repeat;
                    background-size: 100% 100%;
                    border: none;
                }
            }
            .avatar-preview {
                vertical-align: middle;
            }
            .name {
                margin-left: 5px;
                vertical-align: middle;
                display: inline-block;
                word-break: break-all;
                width: 205px;
                line-height: 16px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/page/upManage/Preview.vue